// Transfer between cash accounts (owner 2026-10-17, TRANSFER-KAS). Pure helpers for the
// Buku Kas page; no imports so Jest can test them. Every figure comes from the server.

export const KATEGORI_TRANSFER = ["OTO_TRANSFER_KELUAR", "OTO_TRANSFER_MASUK"];

// a cash entry that belongs to a transfer between accounts (shown with the TRANSFER badge)
export function entriTransfer(row) {
  const kode = row?.efektif?.kategori?.kode;
  return (row?.sumber || {}).tipe === "TRANSFER" || KATEGORI_TRANSFER.includes(kode);
}

// The four summary cards of the book: income and expense leave the transfers out
// (they only move a balance), the transfer card shows what moved, the closing balance counts all.
export function kartuRingkasan(data) {
  if (!data) return [];
  const masuk = data.pemasukan ?? data.total_debet;
  const keluar = data.pengeluaran ?? data.total_kredit;
  const trf = data.transfer_masuk || 0;
  return [
    { kunci: "kas-saldo-awal", label: "Saldo awal", nilai: data.saldo_awal, warna: "text-slate-200" },
    { kunci: "kas-debet", label: "Pemasukan", nilai: masuk, warna: "text-emerald-300" },
    { kunci: "kas-kredit", label: "Pengeluaran", nilai: keluar, warna: "text-red-300" },
    // one account's book: in and out by transfer differ (nilai2 = out); all accounts: they are equal
    { kunci: "kas-transfer", label: data.akun ? "Transfer masuk / keluar" : "Transfer antar akun", warna: "text-sky-300",
      nilai: trf, nilai2: data.akun ? (data.transfer_keluar || 0) : null, catatan: "bukan pemasukan/pengeluaran" },
    { kunci: "kas-saldo-akhir", label: "Saldo akhir", nilai: data.saldo_akhir, warna: "text-amber-300" },
  ];
}

// Warning text under the transfer form after a preview (null when the balance covers it)
export function peringatanSaldo(p) {
  if (!p || p.cukup) return null;
  return `Saldo ${p.dari_akun?.nama || "akun asal"} per ${p.tanggal} hanya ${p.saldo_asal}; setelah transfer menjadi ${p.saldo_asal_sesudah}. Transfer tetap bisa disimpan (peringatan).`;
}

// The payload the form sends: numbers as integers, the past date only when it differs from today
export function susunTransfer(f, hariIni, isOwner) {
  const body = {
    dari_akun: f.dari_akun, ke_akun: f.ke_akun, jumlah: parseInt(f.jumlah, 10) || 0,
    biaya_admin: parseInt(f.biaya_admin, 10) || 0, keterangan: (f.keterangan || "").trim(),
  };
  if (isOwner && f.tanggal && f.tanggal !== hariIni) body.tanggal = f.tanggal;
  return body;
}
